const CASE_CREATION_SESSION_KEY = 'dataunfold_case_creation_active';
const CASE_CREATION_STATE_EVENT = 'dataunfold:case-creation-state-changed';
const CASE_CREATION_TTL_MS = 15 * 60 * 1000;

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.sessionStorage;
};

const readStoredCaseCreationState = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return { active: false, expiresAt: 0 };
  }

  try {
    const raw = storage.getItem(CASE_CREATION_SESSION_KEY);
    if (!raw) {
      return { active: false, expiresAt: 0 };
    }

    const parsed = JSON.parse(raw);
    const expiresAt = Number(parsed?.expiresAt || 0);
    if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
      storage.removeItem(CASE_CREATION_SESSION_KEY);
      return { active: false, expiresAt: 0 };
    }

    return { active: true, expiresAt };
  } catch (error) {
    return { active: false, expiresAt: 0 };
  }
};

const emitCaseCreationStateChange = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new Event(CASE_CREATION_STATE_EVENT));
};

export const startCaseCreation = (ttlMs = CASE_CREATION_TTL_MS) => {
  const storage = getSessionStorage();
  if (!storage) {
    return false;
  }

  try {
    const duration = Number(ttlMs);
    const safeDuration = Number.isFinite(duration) && duration > 0 ? duration : CASE_CREATION_TTL_MS;
    storage.setItem(
      CASE_CREATION_SESSION_KEY,
      JSON.stringify({
        startedAt: Date.now(),
        expiresAt: Date.now() + safeDuration,
      })
    );
    emitCaseCreationStateChange();
    return true;
  } catch (error) {
    return false;
  }
};

export const clearCaseCreation = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return false;
  }

  try {
    storage.removeItem(CASE_CREATION_SESSION_KEY);
  } finally {
    emitCaseCreationStateChange();
  }

  return true;
};

export const isCaseCreationActive = () => readStoredCaseCreationState().active;

export const subscribeToCaseCreationState = (listener) => {
  if (typeof window === 'undefined' || typeof listener !== 'function') {
    return () => {};
  }

  const sync = () => listener(readStoredCaseCreationState().active);
  sync();

  window.addEventListener(CASE_CREATION_STATE_EVENT, sync);
  window.addEventListener('focus', sync);

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', sync);
  }

  return () => {
    window.removeEventListener(CASE_CREATION_STATE_EVENT, sync);
    window.removeEventListener('focus', sync);

    if (typeof document !== 'undefined') {
      document.removeEventListener('visibilitychange', sync);
    }
  };
};
